// V2-Only API Configuration (V1 Deprecated)
const BASE_URL_CONFIG = import.meta.env.VITE_API_URL || '/api';
const VERSION_CONFIG = import.meta.env.VITE_API_VERSION || '/v2';

// API Configuration - V2 Only
export const API_CONFIG = {
  // Base URL for API requests
  BASE_URL: BASE_URL_CONFIG,
  
  // API Version - V2 Only
  VERSION: VERSION_CONFIG,
  
  // Full API base URL
  get FULL_BASE_URL() {
    return `${this.BASE_URL}${this.VERSION}`;
  },
  
  // Timeout for API requests
  TIMEOUT: 30000,
  
  // Helper function to build full endpoint URL
  buildUrl(endpoint: string): string {
    return `${this.FULL_BASE_URL}${endpoint}`;
  },
};

// V2 API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    APPLE: '/auth/apple',
    REFRESH: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    ME: '/user/me',
    PROFILE: '/user/profile',
    CHANGE_PASSWORD: '/user/change-password',
  },
  CLARITY: {
    // V2 Core Endpoints
    REFLECT: '/reveal',
    REVEAL_ASSESS: '/reveal/assess',
    REVEAL_PROCESS: '/reveal/process',
    SAVE: '/save',
    HEALTH: '/health',
    API_INFO: '/api-info',
    METRICS: '/metrics',
    
    // V2 Enhanced Features
    SCENES: '/scenes',
    FRAMES: '/frames',
    GDPR: '/gdpr',
    
    // Deprecated V1 endpoints (for reference only)
    // ADVICE: '/clarity/advice', // DEPRECATED
    // IMPORT: '/clarity/import', // DEPRECATED  
    // GRAPH: '/clarity/graph', // DEPRECATED
    // DECISION_FORKS: '/clarity/decision-forks', // DEPRECATED
    // STATISTICS: '/clarity/decision-forks/statistics', // DEPRECATED
  },
};

// Export individual configs for convenience
export const API_BASE_URL = API_CONFIG.FULL_BASE_URL;
export const API_TIMEOUT = API_CONFIG.TIMEOUT; 